import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';
import querystring from 'query-string';

export default function addItems({
    baseUrl,
    brandId,
    country,
    items,
    wishlistId = '@default',
    uberToken,
    clientId,
    clientSecret,
    additionalHeaders = {},
    addItem: addItemQuery = true,
    allowExistingItems = undefined,
}) {
    invariant(baseUrl, 'baseUrl is a required param of addItem()');
    invariant(brandId, 'brandId is a required param of addItem()');
    invariant(country, 'country is a required param of addItem()');
    invariant(items, 'items is a required param of addItem()');
    invariant(wishlistId, 'wishlistId is a required param of addItem()');
    invariant(uberToken, 'uberToken is a required param of addItem()');
    invariant(clientId, 'clientId is a required param of addItem()');

    const headers = { 'X-Ubertoken': uberToken, 'Content-Type': 'application/json', ...additionalHeaders };
    const query = querystring.stringify({
        addItem: addItemQuery,
        allowExistingItems,
    });
    const urlQuery = query ? `?${query}` : '';
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist/v2/${wishlistId}${urlQuery}`;

    const body = JSON.stringify({
        item: items,
    });

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'PUT', body }), uberToken, clientId, clientSecret),
        'addItem',
    );
}
